import { Container, HardDrive, Wifi } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { DEPLOYMENT_TYPE_OPTIONS } from '../../types/velociraptor-settings'
import { DEPLOY_DOCKER, DEPLOY_EXTERNAL } from './constants'

function getDeploymentIcon(value: string): React.ReactElement {
  if (value === DEPLOY_DOCKER) {
    return <Container className="mt-0.5 h-5 w-5 text-[#5c6e94] dark:text-[#8a9bba]" />
  }
  if (value === DEPLOY_EXTERNAL) {
    return <Wifi className="mt-0.5 h-5 w-5 text-[#5c6e94] dark:text-[#8a9bba]" />
  }
  return <HardDrive className="mt-0.5 h-5 w-5 text-[#5c6e94] dark:text-[#8a9bba]" />
}

interface DeploymentTypeSelectorProps {
  deploymentType: string
  onChange: (value: string) => void
}

interface DeploymentOption {
  value: string
  label: string
  description: string
}

interface DeploymentRadioCardProps {
  option: DeploymentOption
  selected: boolean
  onChange: (value: string) => void
}

function DeploymentRadioCard({
  option,
  selected,
  onChange,
}: DeploymentRadioCardProps): React.ReactElement {
  const containerClass = selected
    ? 'border-[#4e5e82] bg-[#4e5e82]/5 dark:bg-[#8a9bba]/10'
    : 'border-stone-200 dark:border-stone-600'
  return (
    <label
      className={`relative flex cursor-pointer rounded-lg border p-4 focus:outline-none ${containerClass}`}
    >
      <input
        type="radio"
        name="deployment-type"
        value={option.value}
        checked={selected}
        onChange={(ev) => {
          onChange(ev.target.value)
        }}
        className="sr-only"
      />
      <div className="flex items-start gap-3">
        {getDeploymentIcon(option.value)}
        <div>
          <span className="block text-sm font-medium text-stone-900 dark:text-stone-100">
            {option.label}
          </span>
          <span className="mt-0.5 block text-xs text-stone-500 dark:text-stone-400">
            {option.description}
          </span>
        </div>
      </div>
    </label>
  )
}

export function DeploymentTypeSelector({
  deploymentType,
  onChange,
}: DeploymentTypeSelectorProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div>
      <label className="mb-3 block text-sm font-medium text-stone-700 dark:text-stone-300">
        {t('velociraptorSettings.install.deploymentType')}
      </label>
      <div className="grid gap-3 sm:grid-cols-2">
        {DEPLOYMENT_TYPE_OPTIONS.map((option) => (
          <DeploymentRadioCard
            key={option.value}
            option={option}
            selected={deploymentType === option.value}
            onChange={onChange}
          />
        ))}
      </div>
    </div>
  )
}
